import { putRequest, getRequest, postRequest } from ".";

export const postNewPassword = (payload) => {
  return postRequest("/user/change_password", payload);
};

export const resetNewPassword = (payload) => {
  return postRequest("/user/reset-password", payload);
};

export const resetNewPasswordMobile = (payload) => {
  return postRequest("/api/v2/user/reset-password", payload);
};

export const postNewUsername = (payload) => {
  return postRequest("/user/set_profile", payload);
};

export const loginUser = (payload) => {
  return postRequest("/user/login", payload);
};

export const getUser = () => {
  return getRequest("/user");
};

export const getScriptStatus = () => {
  return getRequest("/conversation/script_status?title=GettingToKnowYou");
};

export const updateUser = (id, payload) => {
  return putRequest(`/user/update/${id}`, payload);
};

export const getToKnowYouData = () => {
  return getRequest(`/user/get-to-know-you`);
};
export const latestSubscription = () => {
  return getRequest('/stripe/latest-subscription');
};

export const pauseSubscription = () => {
  return postRequest('/stripe/pause-subscription');
};

export const resumeSubscription = () => {
  return postRequest('/stripe/resume-subscription' );
};

export const cancelSubscription = () => {
  return postRequest('/stripe/cancel-subscription');
};

export const editPreferences = (id,payload) => {
  return putRequest(`/user/update/additonal_services/${id}`, payload);
}

export const createCustomers = (id) => {
  return postRequest(`/stripe/create-customer/${id}`);
}

export const getConversations = (id, page = 1) => {
  return getRequest(`/user/conversations/${id}?page=${page}`);
};

export const getConversationsSentiments = (id) => {
  return getRequest(`/conversation/sentiments/${id}`);
};

export const getBillingHistory = (page, limit) => {
  return getRequest(`/stripe/billing-history?page=${page}&limit=${limit}`);
};

export const getUserSubscriptionDetails = () => {
  return getRequest(`/stripe/subscription-details`);
};

export const getConversationLimit = (userId) => {
  return getRequest(`/conversation/conversation-limit?userId=${userId}`);
};

export const getPlanDetails = () => {
  return getRequest('/stripe/plan-details');
};

export const getOnboardingDetails = () => {
  return getRequest(`/user/onboarding_details`);
};

export const getPaymentMethods = () => {
  return getRequest('/stripe/payment-methods');
}

export const createNewSubscription = (data) => {
  return postRequest(`/stripe/create-new-subscription`, data);
}

export const setDefaultPaymentMethod = (paymentMethodId) => {
  return postRequest(`/stripe/set-default-payment-method`, { paymentMethodId });
}

export const deletePaymentMethod = (paymentMethodId) => {
  return postRequest(`/stripe/delete-payment-method`, { paymentMethodId });
}

export const getInvoice = (paymentIntentId) => {
  return getRequest(`/stripe/invoice?paymentIntentId=${paymentIntentId}`);
}
export const sendPasswordResetEmail = (email) => {
  return postRequest('/user/forgot-password', email);
};

export const getSoftwareVersion = () => {
  return getRequest(`/version/retrieve-latest-version`);
}

export const validateCoupon = (coupon) => {
  return postRequest('/discount/validate-discount', coupon);
};